import React, { Component } from 'react';

class CarEditStatus extends Component{

  render(){
    var car = this.props.car
    return(
      <div className="card card-accent-warning ">
        <div className="card-header">
          <strong>แก้ไขสถานะรถ</strong>
        </div>

          <div className="card-block">

            <div className="row">
              <div className="form-group col-md-12 h5">
                {car.car_name}
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-12 h6">
                  สถานะปัจจุบัน:
                <span
                   className="badge"
                   style={{backgroundColor: car.car_status_color}}
                >
                  {car.car_status_name}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-md-6 text-center">
                <button type="reset"
                        className="btn btn-lg"
                        style={{backgroundColor: '#cfcfcf', width: 200}}
                        onClick={()=>{
                           this.props.onHandle.change(car.car_id, 1)
                        }}
                >
                    กำลังมา
                </button>
              </div>
              <div className="form-group col-md-6 text-center">
                <button type="reset"
                        className="btn btn-lg"
                        style={{backgroundColor: '#f7c407', width: 200}}
                        onClick={()=>{
                          this.props.onHandle.change(car.car_id, 2)
                        }}
                >
                    มาใหม่
                </button>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-md-6 text-center">
                <button type="reset"
                        className="btn btn-lg"
                        style={{backgroundColor: '#72bd44', width: 200}}
                        onClick={()=>{
                          this.props.onHandle.change(car.car_id, 4)
                        }}
                >
                   ซ่อมเสร็จ
                </button>
              </div>

              <div className="form-group col-md-6 text-center">
                <button type="reset"
                        className="btn btn-lg"
                        style={{backgroundColor: '#20a8d8', width: 200}}
                        onClick={()=>{
                          this.props.onHandle.change(car.car_id, 20)
                        }}
                >
                  ประเมินทำสีรถ
                </button>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-md-6 text-center">
                <button type="reset"
                        className="btn btn-lg"
                        style={{backgroundColor: '#1d9ed3', width: 200}}
                        onClick={()=>{
                          this.props.onHandle.change(car.car_id, 6)
                        }}
                >
                  พร้อมขาย
                </button>
              </div>
            </div>

          </div>
          <div className="card-footer text-right">
            <button type="reset"
                    onClick={this.props.onHandle.cancel}
                    className="btn btn-sm btn-danger">
              <i className="fa fa-refresh"></i> ยกเลิก
            </button>
            <button type="submit"
                    className="btn btn-sm btn-primary hidden">
              <i className="fa fa-save"></i> บันทึก
            </button>

            <input type="hidden" id="car_id" name="car_id" value={this.props.car.car_id}/>

          </div>
      </div>
    )
  }
}

export default CarEditStatus
